// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"B0-z","upvoteIcon":"C0-z","downvoteIcon":"D0-z","feedbackIcon":"E0-z"};